import Action from '../../Action';
import './styles/correlation.css'
import { useEffect, useState } from 'react';
import LoadSimple from '../../LoadSimple';
import { capitalizeFirstLetter } from '../../../utils/utils';
// import './styles/ModalAddHost.css'
import { useFetch } from '../../../hooks/useFetch';
import { lang } from '../../generales/traduction';
import Search from '../../generales/Search';
import Paginador from '../../generales/Paginador';
import SelectorAdmin from '../../SelectorAdmin';
import Hosts from '../../../sections/Hosts';
import { ca } from 'date-fns/locale';

const ModalAddCorrelation = ({ dataUsers, dataHosts, editActive, event, languaje, search_problems, appSelected, server, mode, setPoolRows, poolObjectRows, setPoolObjectRows, poolRows, handleShowPopup, closeAddHostModal }) => {
  // console.log(poolRows)
  const [hosts, setHosts] = useState({
    data: [],
    loading: true,
    error: null,
  })
  const [dataEvent, setDataEvent] = useState({
    data: [],
    loading: false,
    error: null,
  })
  const [responseAction, setResponseAction] = useState({
    data: [],
    loading: false,
    error: null,
  })
  const [loading, setLoading] = useState(false)
  const [padreSelected, setPadreSelected] = useState({ hostid: 0, Host: "", latitude: "", longitude: "", ip: "", device_id: 0 })
  const [hijoSelected, setHijoSelected] = useState({ hostid: 0, Host: "", latitude: "", longitude: "", ip: "", device_id: 0 })
  // console.log(poolObjectRows)
  // console.log(poolRows)
  const medios_list = useFetch('cassia/host_correlation/medios', '', '', 'GET', server)
  const [ManttoData, setManttoData] = useState({

    host_padre_id: (editActive) ? event.host_padre_id : 0,
    host_hijo_id: (editActive) ? event.host_hijo_id : 0,
    medio_id: (editActive) ? event.medio_id : 0,
    hostid_origen_status_enlace: (editActive) ? (event.hostid_origen_status_enlace == null ? 0 : event.hostid_origen_status_enlace) : 0,
    itemname_status_enlace: (editActive) ? (event.itemname_status_enlace == null ? "" : event.itemname_status_enlace) : "",
    hostid_origen_throughput_send: (editActive) ? (event.hostid_origen_throughput_send == null ? 0 : event.hostid_origen_throughput_send) : 0,
    itemname_throughput_send: (editActive) ? (event.itemname_throughput_send == null ? "" : event.itemname_throughput_send) : "",
    hostid_origen_throughput_received: (editActive) ? (event.hostid_origen_throughput_received == null ? 0 : event.hostid_origen_throughput_received) : 0,
    itemname_throughput_received: (editActive) ? (event.itemname_throughput_received == null ? "" : event.itemname_throughput_received) : "",
    hostid_origen_alineacion: (editActive) ? (event.hostid_origen_alineacion == null ? 0 : event.hostid_origen_alineacion) : 0,
    itemname_alineacion: (editActive) ? (event.itemname_alineacion == null ? "" : event.itemname_alineacion) : ""

  })
  const [ManttoDataAux, setManttoDataAux] = useState({
    name: "",
    type: "",
    eventids: []
  })
  const [disable, setDisable] = useState(true)
  const levels = [
    {
      id: 1,
      name: 'Padre',
      cassia_criticality_id: 1
    },
    {
      id: 2,
      name: 'Hijo',
      cassia_criticality_id: 2
    }

  ]
  const [metrics, setMetrics] = useState([
    {
      hostid: 0,
      metrics: [],
      loading: false
    },
    {
      hostid: 0,
      metrics: [],
      loading: false
    },


  ])

  const [metricArray, setmetricArray] = useState([0, 0, 0, 0])

  const [metricByHost, setmetricByHost] = useState([
    {
      id: 1,
      data: [],
      loading: false
    },
    {
      id: 2,
      data: [],
      loading: false
    },
    {
      id: 3,
      data: [],
      loading: false
    },
    {
      id: 4,
      data: [],
      loading: false
    }

  ])

  useEffect(() => {
    if (editActive && dataHosts.data.length != 0) {
      setPadreSelected(dataHosts.data.find(e => e.hostid == event.host_padre_id))
      setHijoSelected(dataHosts.data.find(e => e.hostid == event.host_hijo_id))
      metric_byHost(1, event.host_padre_id)
      metric_byHost(2, event.host_hijo_id)
      setmetricArray([
        (event.hostid_origen_status_enlace == event.host_padre_id) ? 1 : 2,
        (event.hostid_origen_throughput_send == event.host_padre_id) ? 1 : 2,
        (event.hostid_origen_throughput_received == event.host_padre_id) ? 1 : 2,
        (event.hostid_origen_alineacion == event.host_padre_id) ? 1 : 2
      ])
      // search_event()
    }
    // buscar_cis();

  }, []);
  useEffect(() => {
    if (editActive && dataHosts.data.length != 0) {
      setPadreSelected(dataHosts.data.find(e => e.hostid == event.host_padre_id))
      setHijoSelected(dataHosts.data.find(e => e.hostid == event.host_hijo_id))

      // search_event()
    }
    // buscar_cis();
  }, [dataHosts.loading]);
  const isManttoDataValid = (data) => {
    return Object.values(data).every(value => value !== 0 && value !== "");
  };
  useEffect(() => {
    // if(ManttoData.name=="" || ManttoData.type=="" ){
    // const valid = isManttoDataValid(ManttoData);
    if (ManttoData.host_hijo_id == 0 || ManttoData.host_padre_id == 0 || ManttoData.medio_id == 0) {
      setDisable(true)
    } else {
      setDisable(false)
    }

  }, [ManttoData])
  const updateMetricById = (id, newData, isLoading) => {
    setmetricByHost(prev =>
      prev.map(item =>
        item.id === id
          ? { ...item, data: newData, loading: isLoading }
          : item
      )
    );
  };
  // const updateMetric = (id, newData, isLoading) => {
  //   setmetricByHost(prev =>
  //     prev.map(item =>
  //       item.id === id
  //         ? { ...item, data: newData, loading: isLoading }
  //         : item
  //     )
  //   );
  // };
  const metric_byHost = async (type, hostid) => {
    //  updateMetricById(index,[],true)
    // const hostid=(type==1)?padreSelected.hostid:hijoSelected.hostid
    if (type === 1) {
      setMetrics(prev => ([
        {
          hostid: hostid,
          metrics: prev[0].metrics,
          loading: true,
        },
        prev[1], // conserva el valor actual
      ]));
    } else if (type === 2) {
      setMetrics(prev => ([
        prev[0], // conserva el valor actual
        {
          hostid: hostid,
          metrics: prev[1].metrics,
          loading: true,
        },
      ]));
    }
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
          "/api/v1/cassia/host_correlation/metrics/by-host/" + hostid,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        // console.log(response);
        if (response.ok) {
          const data1 = await response.json();
          const arrayConIds = data1.data.map((item, index) => ({
            ...item,
            id: index + 1 // o index + 1 si quieres que empiece desde 1
          }));
          //    if (type==1) {
          //   setMetrics([{
          //     hostid:hostid,
          //     metrics:data1.data,
          //     loading:false
          // },metrics[1]])
          //    }else if (type==2) {
          //   setMetrics([metrics[0],{
          //     hostid:hostid,
          //     metrics:data1.data,
          //     loading:false
          // }])
          //    }
          if (type === 1) {
            setMetrics(prev => ([
              {
                hostid: hostid,
                metrics: arrayConIds,
                loading: false,
              },
              prev[1], // conserva el valor actual
            ]));
          } else if (type === 2) {
            setMetrics(prev => ([
              prev[0], // conserva el valor actual
              {
                hostid: hostid,
                metrics: arrayConIds,
                loading: false,
              },
            ]));
          }
          //  updateMetricById(index,data1.data,false)
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };
  const search_event = () => {
    setDataEvent({
      data: dataEvent.data,
      loading: true,
      error: dataEvent.error,
    });

    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
          "/api/v1/cassia/host_correlation/correlaciones/" + event.id,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        if (response.ok) {
          const data1 = await response.json();

          setManttoData(data1.data)
          setDataEvent({
            data: dataEvent.data,
            loading: false,
            error: dataEvent.error,
          });
          setPadreSelected(dataHosts.data.find(e => e.hostid == data1.data.host_padre_id))
          setHijoSelected(dataHosts.data.find(e => e.hostid == data1.data.host_hijo_id))
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };
  const buscar_cis = () => {
    setHosts({
      data: hosts.data,
      loading: true,
      error: hosts.error,
    });

    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
          "/api/v1/cassia/events_correlations/get_events_without_correlation",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        if (response.ok) {
          const data1 = await response.json();

          setHosts({
            data: data1.data,
            loading: false,
            error: hosts.error,
          });
          // setLoading(false)
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };

  const registrar = () => {
    setResponseAction({
      data: responseAction.data,
      loading: true,
      error: responseAction.error,
    });


    const cleanManttoData = Object.fromEntries(
      Object.entries(ManttoData).map(([key, value]) => [
        key,
        value === 0 || value === "" ? null : value
      ])
    );

    // let url=(appSelected.software_type_id==1)?'install_software_serveral_hosts':'install_printer_several_hosts'
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
          "/api/v1/cassia/host_correlation/correlaciones/" + ((editActive) ? event.id : ""),
          {
            method: (editActive) ? "PUT" : "POST",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
            body: JSON.stringify(cleanManttoData)
          }
        );
        if (response.ok) {
          const data1 = await response.json();

          setResponseAction({
            data: data1,
            loading: false,
            error: responseAction.error,
          });
          // setPoolObjectRows([])
          // setPoolRows([])
          handleShowPopup('Completado!!!', '', data1.message, true)
          closeAddHostModal()
          search_problems()
          // setLoading(false)
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          setResponseAction({
            data: responseAction.data,
            loading: false,
            error: responseAction.error,
          });
          handleShowPopup('Error!!!', capitalizeFirstLetter(lang[languaje]['errorActionComplet']), data1.detail, false)
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };
  const [allSelected, setAllSelected] = useState(false);
  const [hostSelected, setHostSelected] = useState([])
  // const [hostSelected,setHostSelected]=useState(hosts.filter(item => poolRows.includes(item.hostid)))
  const [contRowsSelected, setContRowSelected] = useState(0)
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [limitList, setLimitList] = useState(50);
  const [pageActual, setPageActual] = useState(1);
  const [searchResult, setSearchResult] = useState(null);
  var dataList = searchTerm === "" ? dataHosts.data : searchResults;
  const startLimit = limitList * pageActual - limitList;
  const pages = parseInt(dataList.length / limitList) + 1;
  const [searchResults2, setSearchResults2] = useState([]);
  const [searchTerm2, setSearchTerm2] = useState("");
  const [limitList2, setLimitList2] = useState(50);
  const [pageActual2, setPageActual2] = useState(1);
  const [searchResult2, setSearchResult2] = useState(null);
  var dataList2 = searchTerm2 === "" ? dataHosts.data : searchResults2;
  // console.log(dataList2)
  const startLimit2 = limitList2 * pageActual2 - limitList2;
  const pages2 = parseInt(dataList2.length / limitList2) + 1;
  const [hostSelectorOpen, setHostSelectorOpens] = useState(false)
  // const handleSelectAll = () => {
  //   console.log(hosts)
  //     if (allSelected) {
  //         console.log('*******************allselected')
  //       // Si ya está todo seleccionado, deselecciona todo
  //       setPoolRows([]);
  //       setPoolObjectRows([])
  //     } else {
  //         console.log('******************* non selected')
  //         setPoolRows(hosts.data.map(item => item.cassia_arch_traffic_events_id))
  //         setPoolObjectRows(hosts.data)
  //     }
  //     setAllSelected(!allSelected); // Alterna el estado de seleccionar todo
  //   };
  const handleSearch = (query) => {
    setSearchResult(`Resultados para: ${query}`);
  };
  const handleSelectChange = (e) => {
    setPageActual(1)
    setLimitList(e.target.value); setPageActual(1);
  };
  const handleSelectChange2 = (e) => {
    setPageActual2(1)
    setLimitList2(e.target.value); setPageActual2(1);
  };
  const rowSelected = (elemento) => {
    if (allSelected) {
      setAllSelected(false)
    }

    setPoolRows((prevRows) => {
      // Busca si el hostid ya existe en el array
      // console.log(p)/
      const exists = (elemento.eventid == undefined) ? prevRows.includes(elemento.cassia_arch_traffic_events_id) : prevRows.includes(elemento.eventid);
      // Si existe, filtra para eliminarlo, si no existe, lo agrega
      if (exists) {
        return (elemento.eventid == undefined) ? prevRows.filter(cassia_arch_traffic_events_id => cassia_arch_traffic_events_id !== elemento.cassia_arch_traffic_events_id) : prevRows.filter(eventid => eventid !== elemento.eventid);
      } else {
        return [...prevRows, (elemento.eventid == undefined) ? elemento.cassia_arch_traffic_events_id : elemento.eventid];
      }
    });
    setPoolObjectRows((prevRows) => {
      const getId = (obj) => obj?.cassia_arch_traffic_events_id ?? obj?.eventid;

      const newId = getId(elemento);

      const exists = prevRows.some(evento => getId(evento) === newId);

      if (exists) {
        return prevRows.filter(evento => getId(evento) !== newId);
      } else {
        return [...prevRows, elemento];
      }
    });
    // setPoolObjectRows((prevRows) => {
    //   // Busca si el hostid ya existe en el array

    //   const exists = prevRows.some(evento => evento.cassia_arch_traffic_events_id === elemento.cassia_arch_traffic_events_id);
    //   // Si existe, filtra para eliminarlo, si no existe, lo agrega
    //   if (exists) {
    //     return prevRows.filter(evento => evento.cassia_arch_traffic_events_id !== elemento.cassia_arch_traffic_events_id);
    //   } else {
    //     return [...prevRows, elemento];

    //   }
    // });
    setHostSelected((prevRows) => {
      // Busca si el hostid ya existe en el array de objetos
      const exists = prevRows.some(item => item.hostid === elemento.hostid);

      // Si existe, filtra para eliminar el objeto, si no existe, lo agrega
      if (exists) {
        return prevRows.filter(item => item.hostid !== elemento.hostid);
      } else {
        return [...prevRows, elemento];
      }
    });
  };
  const handleChange = (e) => {
    const { name, value } = e.target

    setManttoData((prevState) => {
      return {
        ...prevState,
        [name]: value
      }

    })
  }
  const changeOption = (option, index) => {
    if (option.filter == 'Severity') {
      setmetricArray(prev => {
        const updated = [...prev];     // copia del array
        updated[(index - 1)] = option.id;     // cambio en el índice deseado
        return updated;                // nuevo array
      });
      // metric_byHost(option.id,index)
      const hostid = (option.id == 1) ? padreSelected.hostid : hijoSelected.hostid
      if (index == 1) {
        setManttoData((prevState) => {
          return {
            ...prevState,
            ['hostid_origen_status_enlace']: hostid
          }

        })
      }
      if (index == 2) {
        setManttoData((prevState) => {
          return {
            ...prevState,
            ['hostid_origen_throughput_send']: hostid
          }

        })
      }
      if (index == 3) {
        setManttoData((prevState) => {
          return {
            ...prevState,
            ['hostid_origen_throughput_received']: hostid
          }

        })
      }
      if (index == 4) {
        setManttoData((prevState) => {
          return {
            ...prevState,
            ['hostid_origen_alineacion']: hostid
          }

        })
      }
    }
    if (option.filter == 'Event') {

      //  const hostid=(type==1)?padreSelected.hostid:hijoSelected.hostid
      if (index == 1) {
        setManttoData((prevState) => {
          return {
            ...prevState,
            ['itemname_status_enlace']: option.label
          }

        })
      }
      if (index == 2) {
        setManttoData((prevState) => {
          return {
            ...prevState,
            ['itemname_throughput_send']: option.label
          }

        })
      }
      if (index == 3) {
        setManttoData((prevState) => {
          return {
            ...prevState,
            ['itemname_throughput_received']: option.label
          }

        })
      }
      if (index == 4) {
        setManttoData((prevState) => {
          return {
            ...prevState,
            ['itemname_alineacion']: option.label
          }

        })
      }
    }
    if (option.filter == 'period') {
      setManttoData((prevState) => {
        return {
          ...prevState,
          ['medio_id']: option.id
        }

      })
    }
    // setManttoData((prevState)=>{
    //     return {
    //         ...prevState,
    //         ['type']:option.label
    //     }

    // })
  }
  const [changeEdtHost, setChangeEdtHost] = useState(false)
  const clickPadre = (elemento) => {
    metric_byHost(1, elemento.hostid)
    setChangeEdtHost(true)
    setmetricArray([0, 0, 0, 0])
    setPadreSelected(elemento)
    setManttoData((prevState) => {
      return {
        ...prevState,
        ['host_padre_id']: elemento.hostid
      }

    })
  }
  const clickHijo = (elemento) => {
    metric_byHost(2, elemento.hostid)
    setChangeEdtHost(true)
    setmetricArray([0, 0, 0, 0])
    setHijoSelected(elemento)
    setManttoData((prevState) => {
      return {
        ...prevState,
        ['host_hijo_id']: elemento.hostid
      }

    })
  }

  const { name, type } = ManttoData;
  return (
    <>
      <div className="modal-GS-content">
        <div className='card-modal-gs modal-verificate' style={{ overflow: 'auto' }}>
          <div className='head-card-modal-gs'>
            <div className='title-head-card-modal-gs'>
              {capitalizeFirstLetter(lang[languaje][(editActive) ? 'editarCorrelacion' : 'crearCorrelacion']) + "ii"}
            </div>
          </div>
          {
            <>
              {
                (dataHosts.loading || dataEvent.loading || (editActive && (metrics[0].loading || metrics[1].loading) && changeEdtHost == false)) ? <div className='head-card-modal-gs' style={{ height: '95%' }}>
                  <LoadSimple></LoadSimple>
                </div> :
                  <><div className='head-card-modal-gs' style={{ height: '20%' }}>
                    <div className='content-card-modal-gs' style={{ width: '65%' }}>
                      <div className="form-GS-box">



                        <div className="user-box-GS" style={{ height: '45%' }}>
                          <input required name="name" type="text" value={padreSelected.Host}
                            onChange={handleChange} disabled />
                          <label className='label-GS  ' style={{ top: '-25' }}>{capitalizeFirstLetter(lang[languaje]['hostPadre'])}</label>

                        </div>

                        <div className="user-box-GS" style={{ height: '45%' }}>
                          <input required name="name" type="text" value={hijoSelected.Host}
                            onChange={handleChange} disabled />
                          <label className='label-GS  ' style={{ top: '-25' }}>{capitalizeFirstLetter(lang[languaje]['hostHijo'])}</label>

                        </div>
                        <div className="user-box-GS" style={{ height: '10%' }}>
                          <div className="btnSelectHostsCorrelaton" onClick={() => setHostSelectorOpens(!hostSelectorOpen)}  >
                            {capitalizeFirstLetter(lang[languaje]['seleccionarDispositivos'])}
                            <div className="contArrowSelected">
                              <img
                                src={
                                  "/iconos/" + ((!hostSelectorOpen) ? "down-arrow-select.png" : "up-arrow-select.png")

                                }
                                style={{ width: '20%' }}
                                name="open"
                              />
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                    <div className='content-card-modal-gs' style={{ overflowY: 'scroll', scrollbarWidth: 'thin', height: '60%', display: (hostSelectorOpen) ? 'flex' : 'none' }}>
                      <div className='half-content-card-modal-gs'>
                        <>
                          <div className='head-cis'>
                            <div className='title-cis'>
                              <Search
                                searchResults={searchResults}
                                setSearchResults={setSearchResults}
                                searchTerm={searchTerm}
                                setSearchTerm={setSearchTerm}
                                onSearch={handleSearch}
                                dataObject={dataHosts.data}
                                searchResult={searchResult}
                                setSearchResult={setSearchResult}
                                languaje={languaje}
                              />
                              <div className={"cont-result-registers" + mode} style={{ width: '25%', bottom: '0px' }}>

                                {/* <p style={{  textAlign: "center" ,fontSize:'var(--font-size-xSmall)'}}>
                  &nbsp;
                  {capitalizeFirstLetter(lang[languaje]['resultadosEncontrados'])+" (" +
                    dataList.length +
                    ") " 
                    }
                </p>  */}
                              </div>



                            </div>

                          </div>
                          <div className='cont-cis'>
                            <>
                              <div className="main-panel-cis">
                                <div className="compact-content-portafolio">
                                  <div className={"content-portafolio-head" + mode}>
                                    {
                                      capitalizeFirstLetter(lang[languaje]['seleccionarDispositivoPadre'])
                                    }
                                  </div>
                                  <div className="content-portafolio">
                                    <div className="cont-portafolio-table">
                                      <div className="content-card-portafolio" id="content">

                                        <div className="cont-table-portafolio">
                                          <div className={"head-table-portafolio" + mode}>
                                            <div className="compact-head-table-portafolio">

                                              {/* <div className="field-head-table-mantenimiento field-small"> ID</div> */}
                                              <div className="field-head-table-mantenimiento field-medium" style={{ width: '15%' }}>{'Host ID'}</div>
                                              <div className="field-head-table-mantenimiento field-medium" style={{ width: '60%' }}>{capitalizeFirstLetter(lang[languaje]['dispositivo'])}</div>
                                              <div className="field-head-table-mantenimiento field-larger" style={{ width: '25%' }} >{'IP'} </div>
                                            </div>
                                          </div>
                                          <div className="body-table-portafolio">
                                            {(dataHosts.loading) ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}><LoadSimple /></div> :
                                              <>
                                                <div className="cont-row-user-list">
                                                  {(
                                                    // dataList
                                                    //   .slice(startLimit, parseInt(pageActual) * parseInt(limitList))
                                                    //  hosts.data.data.map((elemento, indice) => (
                                                    (dataList
                                                      .slice(startLimit, parseInt(pageActual) * parseInt(limitList)).map((elemento, indice) => (
                                                        <div
                                                          className={"row-table-portafolio" + mode}
                                                          key={indice}
                                                          onClick={() => { clickPadre(elemento) }}
                                                          style={{ background: ((padreSelected.hostid == elemento.hostid) ? 'var(--forth-color)' : ''), color: (padreSelected.hostid == elemento.hostid) ? 'var(--white-color)' : 'var(--txt-color)' }}
                                                        >


                                                          <div className="field-body-table-mantenimiento field-larger" style={{ width: '15%' }}>
                                                            {elemento.hostid}

                                                          </div>
                                                          {


                                                            <div className="field-body-table-mantenimiento field-medium" style={{ width: '60%' }}>
                                                              {elemento.Host}
                                                            </div>
                                                          }
                                                          <div className="field-body-table-mantenimiento field-medium" style={{ width: '25%' }}>
                                                            {elemento.ip}
                                                          </div>

                                                        </div>
                                                      )))

                                                  )}
                                                  {(dataList.length == 0) ? (
                                                    <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}.</div>
                                                  ) : (
                                                    ""
                                                  )}
                                                </div>

                                              </>
                                            }
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                  </div>
                                  <div className={"content-portafolio-footer" + mode}>
                                    <div className="cont-display-paginador" style={{ position: 'absolute', left: '0%', justifyContent: 'start' }}>

                                      {/* <div className={"cont-half-display-paginador"+mode}>
          <p style={{  textAlign: "center" }}>
                          &nbsp;
                          {(contRowsSelected!=0)?"("+contRowsSelected+")  registros seleccionados":''}
                    </p> 
                
          </div> */}
                                    </div>
                                    <div className="cont-display-paginador" style={{ width: '60%' }}>
                                      <Paginador pages={pages}
                                        pageActual={pageActual}
                                        setPageActual={setPageActual}
                                        mode={mode}></Paginador>
                                    </div>
                                    <div className="cont-display-paginador" style={{ width: '50%' }}>
                                      <div className={"cont-half-display-paginador" + mode}>

                                        <div>
                                          <label htmlFor="selector">{capitalizeFirstLetter(lang[languaje]['filasPagina'])}: </label>
                                          <select id="selector" value={limitList} className="pageSelector" onChange={handleSelectChange}>
                                            <option value={10}>10</option>
                                            <option value={50} >50</option>
                                            <option value={100}>100</option>
                                            <option value={500}>500</option>
                                            <option value={1000}>1000</option>
                                          </select>


                                        </div>
                                      </div>
                                      <div className={"cont-half-display-paginador" + mode} >
                                        <p style={{ textAlign: "center", fontSize: 'var(--font-size-xSmall) !important' }}>
                                          &nbsp;
                                          {"(" +
                                            (startLimit + 1) +
                                            " - " +
                                            (dataList.length > parseInt(pageActual) * parseInt(limitList)
                                              ? parseInt(pageActual) * parseInt(limitList)
                                              : dataList.length) +
                                            ")  " + lang[languaje]['de'] + " " +
                                            dataList.length +
                                            " " + lang[languaje]['resultados']}
                                        </p>

                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>

                            </>

                          </div>
                        </>

                      </div>
                      <div className='half-content-card-modal-gs'>
                        <>
                          <div className='head-cis'>
                            <div className='title-cis'>
                              <Search
                                searchResults={searchResults2}
                                setSearchResults={setSearchResults2}
                                searchTerm={searchTerm2}
                                setSearchTerm={setSearchTerm2}
                                onSearch={handleSearch}
                                dataObject={dataHosts.data}
                                searchResult={searchResult2}
                                setSearchResult={setSearchResult2}
                                languaje={languaje}
                              />
                              <div className={"cont-result-registers" + mode} style={{ width: '25%', bottom: '0px' }}>

                                {/* <p style={{  textAlign: "center" ,fontSize:'var(--font-size-xSmall)'}}>
                  &nbsp;
                  {capitalizeFirstLetter(lang[languaje]['resultadosEncontrados'])+" (" +
                    dataList.length +
                    ") " 
                    }
                </p>  */}
                              </div>



                            </div>

                          </div>
                          <div className='cont-cis'>
                            <>
                              <div className="main-panel-cis">
                                <div className="compact-content-portafolio">
                                  <div className={"content-portafolio-head" + mode}>
                                    {
                                      capitalizeFirstLetter(lang[languaje]['seleccionarDispositivoHijo'])
                                    }
                                  </div>
                                  <div className="content-portafolio">
                                    <div className="cont-portafolio-table">
                                      <div className="content-card-portafolio" id="content">

                                        <div className="cont-table-portafolio">
                                          <div className={"head-table-portafolio" + mode}>
                                            <div className="compact-head-table-portafolio">

                                              {/* <div className="field-head-table-mantenimiento field-small"> ID</div> */}
                                              <div className="field-head-table-mantenimiento field-medium" style={{ width: '15%' }}>{'Host ID'}</div>
                                              <div className="field-head-table-mantenimiento field-medium" style={{ width: '60%' }}>{capitalizeFirstLetter(lang[languaje]['dispositivo'])}</div>
                                              <div className="field-head-table-mantenimiento field-larger" style={{ width: '25%' }} >{'IP'} </div>
                                              {/* <div className="field-head-table-mantenimiento field-larger" style={{width:'20%'}} >{'Status'} </div> */}

                                            </div>
                                          </div>
                                          <div className="body-table-portafolio">
                                            {(dataHosts.loading) ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}><LoadSimple /></div> :
                                              <>
                                                <div className="cont-row-user-list">
                                                  {(
                                                    // dataList
                                                    //   .slice(startLimit, parseInt(pageActual) * parseInt(limitList))
                                                    //  hosts.data.data.map((elemento, indice) => (
                                                    (dataList2
                                                      .slice(startLimit2, parseInt(pageActual2) * parseInt(limitList2)).map((elemento, indice) => (
                                                        <div
                                                          className={"row-table-portafolio" + mode}
                                                          key={indice}
                                                          onClick={() => {
                                                            clickHijo(elemento)
                                                          }}
                                                          style={{ background: ((padreSelected.hostid == elemento.hostid) ? 'var(--border-table-color)' : ((hijoSelected.hostid == elemento.hostid) ? 'var(--forth-color)' : '')), color: (hijoSelected.hostid == elemento.hostid) ? 'var(--white-color)' : 'var(--txt-color)', pointerEvents: (padreSelected.hostid == elemento.hostid) ? 'none' : 'all' }}
                                                        >


                                                          <div className="field-body-table-mantenimiento field-larger" style={{ width: '15%' }}>
                                                            {elemento.hostid}

                                                          </div>
                                                          {


                                                            <div className="field-body-table-mantenimiento field-medium" style={{ width: '60%' }}>
                                                              {elemento.Host}
                                                            </div>
                                                          }
                                                          <div className="field-body-table-mantenimiento field-medium" style={{ width: '25%' }}>
                                                            {elemento.ip}
                                                          </div>
                                                          {/* <div className="field-body-table-mantenimiento field-medium" style={{width:'20%',color:(elemento.status=='RESOLVED')?'var(--green)':'red'}}>
                {elemento.status}
              </div> */}

                                                        </div>
                                                      )))

                                                  )}
                                                  {(dataList2.length == 0) ? (
                                                    <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}.</div>
                                                  ) : (
                                                    ""
                                                  )}
                                                </div>

                                              </>
                                            }
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                  </div>
                                  <div className={"content-portafolio-footer" + mode}>
                                    <div className="cont-display-paginador" style={{ position: 'absolute', left: '0%', justifyContent: 'start' }}>

                                      {/* <div className={"cont-half-display-paginador"+mode}>
          <p style={{  textAlign: "center" }}>
                          &nbsp;
                          {(contRowsSelected!=0)?"("+contRowsSelected+")  registros seleccionados":''}
                    </p> 
                
          </div> */}
                                    </div>
                                    <div className="cont-display-paginador" style={{ width: '60%' }}>
                                      <Paginador pages={pages2}
                                        pageActual={pageActual2}
                                        setPageActual={setPageActual2}
                                        mode={mode}></Paginador>
                                    </div>
                                    <div className="cont-display-paginador" style={{ width: '50%' }}>
                                      <div className={"cont-half-display-paginador" + mode}>

                                        <div>
                                          <label htmlFor="selector">{capitalizeFirstLetter(lang[languaje]['filasPagina'])}: </label>
                                          <select id="selector" value={limitList2} className="pageSelector" onChange={handleSelectChange2}>
                                            <option value={10}>10</option>
                                            <option value={50} >50</option>
                                            <option value={100}>100</option>
                                            <option value={500}>500</option>
                                            <option value={1000}>1000</option>
                                          </select>


                                        </div>
                                      </div>
                                      <div className={"cont-half-display-paginador" + mode} >
                                        <p style={{ textAlign: "center", fontSize: 'var(--font-size-xSmall) !important' }}>
                                          &nbsp;
                                          {"(" +
                                            (startLimit2 + 1) +
                                            " - " +
                                            (dataList2.length > parseInt(pageActual2) * parseInt(limitList2)
                                              ? parseInt(pageActual2) * parseInt(limitList2)
                                              : dataList2.length) +
                                            ")  " + lang[languaje]['de'] + " " +
                                            dataList2.length +
                                            " " + lang[languaje]['resultados']}
                                        </p>

                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>

                            </>

                          </div>
                        </>

                      </div>
                      {/* <div className='half-content-card-modal-gs'>
                  <>
              <div className='head-cis'>
              <div className="cont-buttons-panel" style={{width:'50%', display:'flex'} }>
               {
                
                (responseAction.loading)?<LoadSimple></LoadSimple>:
                 
                <>
                <Action
                disabled={disable}
                origen="Azul"
                titulo={(editActive)?capitalizeFirstLetter(lang[languaje]['editar']):capitalizeFirstLetter(lang[languaje]['crear'])}
                action={registrar}
              />
              
                </>
                
               }
                  
                
                  <Action
              disabled={false}
              origen="Cancelar"
              titulo={""+capitalizeFirstLetter(lang[languaje]['cancelar'])}
              action={closeAddHostModal}
            />
              </div>
              
              </div>
          <div className='cont-cis'>
          <>
    <div className="main-panel-cis">
    <div className="compact-content-portafolio">
    <div className={"content-portafolio-head"+mode} style={{background:'var(--third-color)',color:'var(--white-color)'}}>
              <div className='title-host-added'>{'Eventos Seleccionados'}</div>
            </div>
      <div className="content-portafolio">
        <div className="cont-portafolio-table">
          <div className="content-card-portafolio" id="content">
           
          <div className="cont-table-portafolio">
    
    <div className="body-table-portafolio">
    
    <>
    <div className="cont-row-user-list">
      
      {(
        poolObjectRows
          .map((elemento, indice) => (
              <div className='content-row-host-selected' key={indice}>
              <div className='row-host-selected'>
                  <div className='text-host-selected'>
                    {
                      (elemento.eventid==undefined)?
                      elemento.cassia_arch_traffic_events_id+' / '+elemento.message+" / "+elemento.afiliacion:
                      elemento.eventid+' / '+elemento.Problem+" / "+elemento.affiliation
                     
                    }
                 
                  </div>
                  <div className='delete-host-selected' onClick={(()=>rowSelected(elemento))}>
                                  X
                  </div>
              </div>              
          </div>
          ))
      )}
      { (poolObjectRows.length == 0 ) ? (
        <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}.</div>
      ) : (
        ""
      )}
    </div>
    
  </>
  
    </div>
  </div>
          </div>
        </div>

        </div>
        <div className={"content-portafolio-footer"+mode} style={{justifyContent:'center'}}>
        <div className="cont-display-paginador" style={{position: 'absolute',justifyContent: 'center',width:'50%'}}>
          
          <div className={"cont-half-display-paginador"+mode}>
          <p style={{  textAlign: "center" }}>
                          &nbsp;
                          {"("+poolRows.length+")  registros seleccionados"}
                    </p> 
                
          </div>
        </div>  
        
         
                  
      </div>
      </div>
    </div>
    
  </>
              
          </div>
 </>
                  </div> */}
                    </div>
                    <div className='head-card-modal-gs' style={{ height: '60%' }}>
                      <div className='content-card-modal-gs' style={{ width: '65%' }}>
                        {<div className="form-GS-box">

                          {(padreSelected.hostid != 0 && hijoSelected.hostid != 0) ? <>

                            <div className="user-box-GS " style={{ height: '50%' }}>
                              {
                                (medios_list.loading) ? <div style={{ width: '100%' }}>Cargando. . .</div> :
                                  <SelectorAdmin placeholder={'Seleccionar tipo...'} opGeneral={true} txtOpGen={''} opt_de={(editActive) ? ManttoData.medio_id : 0} origen={'Admin'} data={medios_list.data.data} loading={medios_list.loading} titulo='period' selectFunction={changeOption} index={0}></SelectorAdmin>
                              }
                              <label className='label-GS'>{'Medio'}</label>

                            </div>

                            <div className="user-box-GS " style={{ height: '25%' }}>
                              {
                                (medios_list.loading) ? <div style={{ width: '100%' }}>Cargando. . .</div> :
                                  <SelectorAdmin placeholder={'Seleccionar tipo...'} opGeneral={true} txtOpGen={''}
                                    opt_de={(editActive) ? ((changeEdtHost || event.hostid_origen_status_enlace == null) ? 0 : ((event.hostid_origen_status_enlace == ManttoData.host_padre_id) ? 1 : 2)) : 0}
                                    origen={'Admin'} data={levels} loading={medios_list.loading} titulo='Severity' selectFunction={changeOption} index={1}></SelectorAdmin>
                              }

                              <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['enlace'])}-{capitalizeFirstLetter(lang[languaje]['status'])}</label>
                              {
                                (metricByHost[0].loading) ? <div style={{ width: '100%' }}>Cargando. . .</div> :
                                  <SelectorAdmin placeholder={'Seleccionar tipo...'} opGeneral={true} txtOpGen={''}
                                    // opt_de={(editActive)? ((changeEdtHost)?0:((metricArray[0]==0)?0:metrics[(metricArray[0]-1)].metrics.find(item => item.name === event.itemname_status_enlace).id)):0} 
                                    opt_de={
                                      !editActive || changeEdtHost || metricArray[0] === 0
                                        ? 0
                                        : metrics[metricArray[0] - 1]?.metrics.find(
                                          item => item.name === event.itemname_status_enlace
                                        )?.id || 0
                                    }
                                    origen={'Admin'} data={(metricArray[0] == 0) ? [] : metrics[(metricArray[0] - 1)].metrics} loading={metricByHost[0].loading} titulo='Event' selectFunction={changeOption} index={1}></SelectorAdmin>
                              }

                              {/* <label className='label-GS' style={{left:'50%'}}>{capitalizeFirstLetter(lang[languaje]['tipo'])}</label>  */}

                            </div>
                            <div className="user-box-GS " style={{ height: '25%' }}>
                              {
                                (medios_list.loading) ? <div style={{ width: '100%' }}>Cargando. . .</div> :
                                  <SelectorAdmin placeholder={'Seleccionar tipo...'} opGeneral={true} txtOpGen={''}
                                    // opt_de={(editActive)? ((event.hostid_origen_throughput_send==ManttoData.host_padre_id)?1:2):0} 
                                    opt_de={(editActive) ? ((changeEdtHost || event.hostid_origen_throughput_send == null) ? 0 : ((event.hostid_origen_throughput_send == ManttoData.host_padre_id) ? 1 : 2)) : 0}
                                    origen={'Admin'} data={levels} loading={medios_list.loading} titulo='Severity' selectFunction={changeOption} index={2}></SelectorAdmin>
                              }

                              <label className='label-GS'>{'Throughput Send'}</label>
                              {
                                (metricByHost[1].loading) ? <div style={{ width: '100%' }}>Cargando. . .</div> :
                                  <SelectorAdmin placeholder={'Seleccionar tipo...'} opGeneral={true} txtOpGen={''}
                                    // opt_de={(editActive)? ((metricArray[1]==0)?0:metrics[(metricArray[1]-1)].metrics.find(item => item.name === event.itemname_throughput_send).id):0} 
                                    // opt_de={(editActive)? ((changeEdtHost)?0:((metricArray[1]==0)?0:metrics[(metricArray[1]-1)].metrics.find(item => item.name === event.itemname_throughput_send).id)):0} 
                                    opt_de={
                                      !editActive || changeEdtHost || metricArray[1] === 0
                                        ? 0
                                        : metrics[metricArray[1] - 1]?.metrics.find(
                                          item => item.name === event.itemname_throughput_send
                                        )?.id || 0
                                    }
                                    origen={'Admin'} data={(metricArray[1] == 0) ? [] : metrics[(metricArray[1] - 1)].metrics} loading={metricByHost[1].loading} titulo='Event' selectFunction={changeOption} index={2}></SelectorAdmin>
                              }

                              {/* <label className='label-GS' style={{left:'50%'}}>{capitalizeFirstLetter(lang[languaje]['tipo'])}</label>  */}

                            </div>
                            <div className="user-box-GS " style={{ height: '25%' }}>
                              {
                                (medios_list.loading) ? <div style={{ width: '100%' }}>Cargando. . .</div> :
                                  <SelectorAdmin placeholder={'Seleccionar tipo...'} opGeneral={true} txtOpGen={''}
                                    // opt_de={(editActive)? ((event.hostid_origen_throughput_received==ManttoData.host_padre_id)?1:2):0} 
                                    opt_de={(editActive) ? ((changeEdtHost || event.hostid_origen_throughput_received == null) ? 0 : ((event.hostid_origen_throughput_received == ManttoData.host_padre_id) ? 1 : 2)) : 0}
                                    origen={'Admin'} data={levels} loading={medios_list.loading} titulo='Severity' selectFunction={changeOption} index={3}></SelectorAdmin>
                              }

                              <label className='label-GS'>{'Throughput Recv'}</label>
                              {
                                (metricByHost[2].loading) ? <div style={{ width: '100%' }}>Cargando. . .</div> :
                                  <SelectorAdmin placeholder={'Seleccionar tipo...'} opGeneral={true} txtOpGen={''}
                                    // opt_de={(editActive)? ((metricArray[2]==0)?0:metrics[(metricArray[2]-1)].metrics.find(item => item.name === event.itemname_throughput_received).id):0} 
                                    // opt_de={(editActive)? ((changeEdtHost)?0:((metricArray[2]==0)?0:metrics[(metricArray[2]-1)].metrics.find(item => item.name === event.itemname_throughput_received).id)):0} 
                                    opt_de={
                                      !editActive || changeEdtHost || metricArray[2] === 0
                                        ? 0
                                        : metrics[metricArray[2] - 1]?.metrics.find(
                                          item => item.name === event.itemname_throughput_received
                                        )?.id || 0
                                    }
                                    rigen={'Admin'} data={(metricArray[2] == 0) ? [] : metrics[(metricArray[2] - 1)].metrics} loading={metricByHost[2].loading} titulo='Event' selectFunction={changeOption} index={3}></SelectorAdmin>
                              }

                              {/* <label className='label-GS' style={{left:'50%'}}>{capitalizeFirstLetter(lang[languaje]['tipo'])}</label>  */}

                            </div>
                            <div className="user-box-GS " style={{ height: '25%' }}>
                              {
                                (medios_list.loading) ? <div style={{ width: '100%' }}>Cargando. . .</div> :
                                  <SelectorAdmin placeholder={'Seleccionar tipo...'} opGeneral={true} txtOpGen={''}
                                    // opt_de={(editActive)? ((event.hostid_origen_alineacion==ManttoData.host_padre_id)?1:2):0} 
                                    opt_de={(editActive) ? ((changeEdtHost || event.hostid_origen_alineacion == null) ? 0 : ((event.hostid_origen_alineacion == ManttoData.host_padre_id) ? 1 : 2)) : 0}
                                    origen={'Admin'} data={levels} loading={medios_list.loading} titulo='Severity' selectFunction={changeOption} index={4}></SelectorAdmin>
                              }

                              <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['alineacion'])}</label>
                              {
                                (metricByHost[3].loading) ? <div style={{ width: '100%' }}>Cargando. . .</div> :
                                  <SelectorAdmin placeholder={'Seleccionar tipo...'} opGeneral={true} txtOpGen={''}
                                    // opt_de={(editActive)? ((metricArray[3]==0)?0:metrics[(metricArray[3]-1)].metrics.find(item => item.name === event.itemname_alineacion).id):0} 
                                    // opt_de={(editActive)? ((changeEdtHost)?0:((metricArray[3]==0)?0:metrics[(metricArray[3]-1)].metrics.find(item => item.name === event.itemname_alineacion).id)):0} 
                                    opt_de={
                                      !editActive || changeEdtHost || metricArray[3] === 0
                                        ? 0
                                        : metrics[metricArray[3] - 1]?.metrics.find(
                                          item => item.name === event.itemname_alineacion
                                        )?.id || 0
                                    }

                                    origen={'Admin'} data={(metricArray[3] == 0) ? [] : metrics[(metricArray[3] - 1)].metrics} loading={metricByHost[3].loading} titulo='Event' selectFunction={changeOption} index={4}></SelectorAdmin>
                              }

                              {/* <label className='label-GS' style={{left:'50%'}}>{capitalizeFirstLetter(lang[languaje]['tipo'])}</label>  */}

                            </div>
                          </> : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'var(--red-alert)', width: '100%', height: '50%' }}>{capitalizeFirstLetter(lang[languaje]['selectPadreHijo'])}</div>}
                          <div className="user-box-GS " style={{ height: '25%' }}>
                            <div className="" style={{ width: '50%', display: 'flex', height: '10%' }}>
                              {

                                ((responseAction.loading)) ? <LoadSimple></LoadSimple> :

                                  <>
                                    <Action
                                      disabled={disable}
                                      origen="Azul"
                                      titulo={(editActive) ? capitalizeFirstLetter(lang[languaje]['editar']) : capitalizeFirstLetter(lang[languaje]['crear'])}
                                      action={registrar}
                                    />
                                    <Action
                                      disabled={false}
                                      origen="Cancelar"
                                      titulo={"" + capitalizeFirstLetter(lang[languaje]['cancelar'])}
                                      action={closeAddHostModal}
                                    />
                                  </>

                              }



                            </div>
                          </div>
                        </div>}
                      </div>
                    </div>

                    {/* <div className="cont-buttons-panel" style={{width:'50%', display:'flex',height:'10%'} }>
               {
                
                (false)?<LoadSimple></LoadSimple>:
                 
                <>
                <Action
                disabled={disable}
                origen="Azul"
                titulo={(editActive)?capitalizeFirstLetter(lang[languaje]['editar']):capitalizeFirstLetter(lang[languaje]['crear'])}
                action={registrar}
              />
              
                </>
                
               }
                  
                
                  <Action
              disabled={false}
              origen="Cancelar"
              titulo={""+capitalizeFirstLetter(lang[languaje]['cancelar'])}
              action={closeAddHostModal}
            />
              </div> */}


                  </>
              }
            </>
          }

        </div>
      </div>
    </>
  );
}

export default ModalAddCorrelation